import React from 'react';
import { Button, Divider, Modal, Space, Typography } from 'antd';
import { IoDocumentTextOutline } from 'react-icons/io5';
const { Title, Text } = Typography;

const TicketComprobante = ({ setIsReciboModalOpen, isReciboModalOpen, reciboSeleccionado, clienteSeleccionado }) => {
  return (
    <Modal
        title={<Space><IoDocumentTextOutline style={{ color: '#22BABB' }} /> <Text strong>COMPROBANTE DE PAGO</Text></Space>}
        open={isReciboModalOpen}
        onCancel={() => setIsReciboModalOpen(false)}
        footer={[
          <Button key="imprimir" type="primary" style={{ backgroundColor: '#22BABB' }} onClick={() => window.print()}>Imprimir Recibo</Button>
        ]}
        width={350}
        centered
      >
        {reciboSeleccionado && (
          <div style={{ padding: '20px', fontFamily: 'monospace', fontSize: '12px' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <Title level={5} style={{ margin: 0 }}>RECIBO DE CAJA</Title>
              <Text>{new Date().toLocaleDateString()}</Text>
            </div>
            <Divider dashed />
            <div style={{ marginBottom: '10px' }}>
              <Text strong>Cliente:</Text> {clienteSeleccionado.nombre}<br />
              <Text strong>Documento:</Text> {clienteSeleccionado.documento}
            </div>
            <div style={{ marginBottom: '10px', fontSize: '14px', background: '#f8fafc', padding: '10px' }}>
              <Text strong>VALOR ABONADO:</Text>
              <Title level={3} style={{ margin: 0, color: '#059669' }}>${Number(reciboSeleccionado.monto).toLocaleString('es-CO')}</Title>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <Text>Saldo Pendiente Actual:</Text><br />
              <Text strong style={{ fontSize: '16px', color: '#dc2626' }}>${Number(clienteSeleccionado.saldo_pendiente).toLocaleString('es-CO')}</Text>
            </div>
            <Divider dashed />
            <div style={{ textAlign: 'center', fontSize: '10px', color: '#64748b' }}>
              *** YUGONUB POS - GRACIAS POR SU PAGO ***
            </div>
          </div>
        )}
      </Modal>
  )
}

export default TicketComprobante;